import React from 'react';

function StatusRb({ value, onChange }) {

    const handleOnChange = (e) => {
        onChange(e.target.value); // Pass the selected value to the parent component
    };

    return (
        <>
            <label className=" font-poppins block mb-2 text-sm font-medium text-gray-900 dark:text-white">Status</label>
            <section className="bg-gray-700 rounded-lg w-[230px] p-3">

                <div className="flex">


                    <div className="flex items-center me-4">
                        <input
                            type="radio"
                            value="upcoming"
                            name="event_status"
                            checked={value === "upcoming"}
                            onChange={handleOnChange}
                            className="w-4 cursor-pointer h-4 text-red-600 bg-gray-100 border-gray-300 focus:ring-red-500 dark:focus:ring-red-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-red-700 dark:border-red-600"
                        />
                        <label htmlFor="inline-radio" className="font-poppins ms-2 text-sm font-medium text-gray-300">
                            Upcoming
                        </label>
                    </div>

                    <div className="flex items-center me-4">
                        <input
                            type="radio"
                            value="complete"
                            name="event_status"
                            checked={value === "complete"}
                            onChange={handleOnChange}
                            defaultChecked
                            className="w-4 h-4 cursor-pointer text-blue-600 bg-gray-100 border-gray-300 focus:ring-red-500 dark:focus:ring-red-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-red-700 dark:border-red-600"
                        />
                        <label htmlFor="inline-2-radio" className="font-poppins ms-2 text-sm font-medium text-gray-300">
                            Complete
                        </label>
                    </div>
                </div>

            </section>
        </>
    );
}

export default StatusRb;
